module.exports = __webpack_public_path__ + "82ee5efafd3466676e178e6ac31ebe01.otf";